(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .service('InvoicePriceCustomService',InvoicePriceCustomService);

    InvoicePriceCustomService.$inject = ['$http'];

    function InvoicePriceCustomService($http) {
        return {
            returnFixationAppliedQtyNoInvoice: returnFixationAppliedQtyNoInvoice,
            returnFixationAppliedQtyWithInvoice: returnFixationAppliedQtyWithInvoice
        };

        function returnFixationAppliedQtyNoInvoice(id) {
            var url = "api/invoice-prices/fixation/" + id + "/applied-qty";
            return $http.get(url);
        }

        function returnFixationAppliedQtyWithInvoice(fixationId, invoiceId) {
            var url = "api/invoice-prices/fixation/" + fixationId + "/invoice/" + invoiceId + "/applied-qty";
            return $http.get(url);
        }
    }
})();
